import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Box, Tooltip, useTheme } from "@mui/material";
export const CompatibilitySymbol = ({ onClick, icon }) => {
    if (!icon)
        return _jsx(_Fragment, {});
    const theme = useTheme();
    return (_jsx(Tooltip, Object.assign({ title: icon === null || icon === void 0 ? void 0 : icon.tooltip }, { children: _jsx(Box, Object.assign({ style: {
                marginLeft: theme.spacing(0.5),
            } }, { children: _jsx("i", { onClick: onClick, className: icon === null || icon === void 0 ? void 0 : icon.icon, style: { color: icon === null || icon === void 0 ? void 0 : icon.color, cursor: "pointer" } }) })) })));
};
